// biome-ignore lint/style/useImportType: legacy import, will be migrated
import { FC } from 'react';

import { useTranslation } from '@crehana/i18n';

interface TitleProps {
  isCampaignTitle: boolean;
}

const Title: FC<React.PropsWithChildren<TitleProps>> = ({
  isCampaignTitle,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {isCampaignTitle ? (
        <>
          <h2 className="mb-8 text-white font-h4" style={{ maxWidth: 650 }}>
            {t('CAMPAIGN_AUTH_TITLE')}
          </h2>
          <h3 className="text-center text-white font-body3">
            {t('CAMPAIGN_AUTH_SUBTITLE')}
          </h3>
        </>
      ) : (
        <>
          <h2 className="text-white font-h2">
            {t('JOIN_CREHANA', 'Únete hoy')}
          </h2>
          <h3 className="text-center text-white font-body3">
            {t('LIVE_EXPERIENCE_CREHANA', 'Empieza tu camino de aprendizaje')}
          </h3>
        </>
      )}
    </>
  );
};

export default Title;
